import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { ALL_SORTED_ACTIVITIES } from 'common/constants';
import { capitalizeString, isDesktop, isEmpty } from 'common/utils';
import { Card, Button, SectionList } from '../';
import './index.css';

const CardList = ({
  cards = [],
  className,
  loading,
  section,
  theme,
  goToPage,
  emptyStateconfig: {
    message,
    btnMessage,
    routeName,
    showActivityTypes = false,
    showAdd = true,
    action,
    firstName,
  },
}) => {
  const CardCSS = cn(
    'cardlist',
    className,
    theme ? theme.map(css => `cardlist--${css}`).join(' ') : ''
  );

  const renderCards = (card, idx) => {
    return (
      <li key={idx} className={'cardlist__item'}>
        <Card
          availableOffline={card.availableOffline}
          handleUnavailableClick={card.handleUnavailableClick}
          link={card.link}
          action={card.action}
          top={card.top}
          footer={
            card.footer && (
              <strong className={'text--fade'}>{card.footer}</strong>
            )
          }
        >
          <h3 className={'cardlist__title'}>{card.title}</h3>
          {card.subtitle && (
            <h5 className={'cardlist__subtitle'}>{card.subtitle}</h5>
          )}
          {card.content}
        </Card>
      </li>
    );
  };

  const renderActivityTypes = () => (
    <Fragment>
      <p className="text--bold text--medium">
        Start planning and logging activities including:{' '}
      </p>
      <ul className="cardlist__activitytype">
        {ALL_SORTED_ACTIVITIES.map(activityType => (
          <li key={activityType}>{capitalizeString(activityType)}</li>
        ))}
      </ul>
    </Fragment>
  );

  const renderEmptyList = () => (
    <Fragment>
      <ul className={CardCSS}>
        {loading ? (
          <li className={'cardlist__placeholder'}>...loading</li>
        ) : (
          <li
            className={cn('cardlist__placeholder', {
              'cardlist__placeholder--tight':
                showActivityTypes ||
                location.pathname.includes('/fields/detail'),
            })}
          >
            {firstName && (
              <p className="text--header text--medium">
                Hi {firstName}, welcome!
              </p>
            )}
            {showActivityTypes && renderActivityTypes()}
            <p className="cardlist__message">{message}</p>
          </li>
        )}
      </ul>
      {showAdd && (
        <Button
          className={cn(
            'btn',
            'btn--secondary',
            'btn--add',
            'btn--margin-below',
            {
              'btn-inner': isDesktop(),
            }
          )}
          onClick={() => {
            action && action();
            routeName && goToPage(routeName);
          }}
        >
          <span className={'visible--desktop'}>{btnMessage}</span>
        </Button>
      )}
    </Fragment>
  );

  const renderListWithData = () => (
    <Fragment>
      {btnMessage && showAdd && (
        <Button
          className="btn btn--secondary btn--add"
          onClick={() => {
            action && action();
            routeName && goToPage(routeName);
          }}
        >
          <span className={'visible--desktop'}>{btnMessage}</span>
        </Button>
      )}
      {section && section.data ? (
        <SectionList {...section} />
      ) : (
        <ul className={CardCSS}>{cards.map(renderCards)}</ul>
      )}
    </Fragment>
  );

  return (section && section.data && !isEmpty(section.data)) ||
    (cards && cards.length > 0)
    ? renderListWithData()
    : renderEmptyList();
};

CardList.propTypes = {
  cards: PropTypes.array,
  className: PropTypes.string,
  loading: PropTypes.bool,
  theme: PropTypes.array,
  emptyStateconfig: PropTypes.shape({
    firstName: PropTypes.string,
    message: PropTypes.string,
    btnMessage: PropTypes.string,
    routeName: PropTypes.string,
    showActivityTypes: PropTypes.bool,
    showAdd: PropTypes.bool,
    action: PropTypes.func,
  }),
  goToPage: PropTypes.func,
  location: PropTypes.object,
  section: PropTypes.object,
};

CardList.defaultProps = {
  emptyStateconfig: {},
};

const mapState = ({ router: { location } }) => ({
  location,
});

const mapDispatch = {
  goToPage: routeName => push(routeName),
};

export default connect(
  mapState,
  mapDispatch
)(CardList);



// WEBPACK FOOTER //
// ./src/common/components/CardList/index.js